import * as t from 'io-ts';

import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {makeApiSerializableType, makeEnumRuntimeType} from './apiTypes';
import {parseTeamPreferences, RTeamPreferences} from './teamPreferencesModel';

/*
 * Runtime type.
 */

const RTeamDirty = t.readonly(
  t.type({
    id: t.Integer,
    namespace: t.string,
    name: t.string,
    color: makeEnumRuntimeType(PaletteColorsEnum),
    preferences: RTeamPreferences,
    updatedAt: t.Integer,
  }),
  'team',
);

/*
 * Type.
 */

export interface TeamModel extends t.TypeOf<typeof RTeamDirty> {}
export const RTeam = t.clean<TeamModel>(RTeamDirty as any);

/*
 * IO methods.
 */

export function parseTeam(src: any): TeamModel {
  // LIGHT_BLUE was deprecated, in favor of TEAL.
  const color = src.color === 'light-blue' ? PaletteColorsEnum.TEAL : src.color;
  return {
    id: src.id,
    namespace: src.namespace,
    name: src.name,
    color,
    preferences: parseTeamPreferences(src.preferences),
    updatedAt: src.updated_at,
  };
}

export function serializeTeam(team: TeamModel): any {
  return {
    name: team.name,
    namespace: team.namespace,
  };
}

/*
 * API type.
 */

export const ApiTeam = makeApiSerializableType('team', RTeam, parseTeam, serializeTeam);
